<script>
  export let currrentStep = 2;
  let step2var1, step2var2;
  let step2error;
  let refreshing = false;
  let attempts = 4;

  const step2 = async () => {
    refreshing = true;
    if (
         (step2var1 == undefined || step2var1.length < 6)
      && (step2var2 == undefined || step2var2.length < 2)
      && (attempts > 1)
      ) {
        step2var1 =''
        step2var2 =''
        attempts = attempts - 1;
        step2error = true;
        refreshing = false;
        document.querySelector("#ahwhodis").focus();
    } else {
      getData();
    }
  };

  const apiURL = '/password/reset/whoyou/q/';

  const getData = async () => {
      const res = await fetch(apiURL + step2var1 + '/sn/' + step2var2);
      if (!res.ok && res.status == '419') {
        console.log(res);
        window.location.reload(true);
      } else if (!res.ok && res.status == '404') {
        step2error = true;
        step2var1 =''
        step2var2 =''
        attempts = attempts - 1;
        document.querySelector("#ahwhodis").focus();
      } else {
        currrentStep = 3;
      };
      refreshing = false;
  }
</script>

<div class="card-body">
  <div class="alert alert-danger" class:hide={!step2error}>
    Verification failed; try again
  </div>
  <div class="alert alert-info" class:hide={!step2error}>
    {attempts} attempt{attempts==1 ? '' : 's'} left.
    {#if attempts==0}
    Please wait 5 minutes and try again.
    <hr>
    <a href="/password/index/reset" class="btn btn-secondary me-4">Back</a>
    {/if}
  </div>

  <form class:hide={!attempts}>
    <div class="row">
      <div class="mb-3 col-auto">
        <label for="ahwhodis" class="form-label">
          What is your Student/Staff ID number?
        </label>
        <input
          type="text"
          class="form-control"
          id="ahwhodis"
          bind:value={step2var1}
          autocomplete="off"
          maxlength="16"
          pattern="[0-9]{(7, 16)}"
          autofocus
          required
        />
      </div>
    </div>

    <div class="row">
      <div class="mb-3 col-auto">
        <label for="exampleFormControlTextarea1" class="form-label"
          >What is your last name?</label
        >
        <input type="text" class="form-control" bind:value={step2var2} />
      </div>
    </div>

    <div class="">
      <button
        type="submit"
        class="btn btn-secondary"
        on:click|preventDefault={step2}
      >
        {#if refreshing}
          <span><i class="fas fa-spinner fa-spin" /></span>
        {:else}
          <span>OK</span>
        {/if}
      </button>
      <a href="/password/rest" class="btn btn-outline-secondary">Cancel</a>
    </div>
  </form>
</div>

<style>
</style>
